import ReactGA from 'react-ga4';
import { BOOKING } from "../constants";

// LEGACY... REMOVE
export const eventGA = (category, action, label) => ReactGA.event({ category, action, label });

export const sendBookingConversion = booking => {
  const isCabin = booking.subject === BOOKING.CABIN_SUBJECT;
  const bookingLabel = isCabin ? 'Cabin Booking' : 'Yacht Booking';
  const quantity = isCabin ? booking.bookedCabinWeeks.length : 1;
  ReactGA.plugin.require('ecommerce');
  ReactGA.plugin.execute('ecommerce', 'addTransaction', {
    id: booking.id,
    revenue: booking.mainOrder.gross / 100,
    currency: booking.mainOrder.currency
  });
  ReactGA.plugin.execute('ecommerce', 'addItem', {
    id: booking.id,
    name: `${bookingLabel} - ${booking.destination.name}`,
    sku: `${booking.destination.country}w${booking.week.week}`,
    category: bookingLabel,
    price: booking.mainOrder.gross / quantity / 100,
    quantity
  });
  ReactGA.plugin.execute('ecommerce', 'send');

  if (window.fbq) {
    window.fbq('track', 'Purchase', {
      value: booking.mainOrder.gross / 100,
      currency: booking.mainOrder.currency,
      content_ids: booking.id,
      content_type: booking.subject
    });
  }
};


